/* * 地图容器组件 * @module components/mapbase/OlBaseMap * @desc 用于展示地图 * @author zhaoting *
@date 2019年12月16日 * @param {Array} [center] - 地图默认中心坐标 * @param {Number} [zoom] -
地图缩放级别 */
<template>
  <div id="olmapdiv">
    <div :id="tagertId" class="basemap" ref="olmap">
      <div id="mouse-position"></div>
    </div>
    <div id="scalebar"></div>
    <!-- 二维三维数据的切换 -->
    <MapTools  />
    <div
      id="mapType-wrapper"
      @mouseleave.stop="switchmap()"
      @mouseenter.stop="showswitchmap()"
      v-if="isSwitchMap"
      :class="switchMapPosition"
      style="z-index: 99999999"
    >
      <div id="mapType">
        <div class="mapTypeCard earth" data-name="earth" @click.stop="showimagelayer()">
          <span>影像</span>
        </div>
        <div
          class="mapTypeCard normal choosedType active"
          data-name="normalMap"
          @click.stop="showvector()"
        >
          <span>矢量</span>
        </div>
      </div>
    </div>
    <MapVideoTip :modal1="modal1" :videourl="videourl" @childFn="parentvideoFn"></MapVideoTip>
    <MapdetailTip
      :modal2="modal2"
      :environment-arr="environmentArr"
      @childFn="parentdetailFn"
    ></MapdetailTip>
    <Modal
      title="附件"
      v-model="mideaModalVisible"
      :draggable="true"
      :width="500"
      :transfer="false"
      class-name="midea-modal"
      :z-index="zIndex"
      :mask="false"
    >
      <Table
        class="midea_table"
        :loading="loading"
        border
        :columns="columns_midea"
        :data="mideaInfo"
        ref="table"
      ></Table>

      <div slot="footer">
        <Upload
          ref="upload"
          style="display: inline-block"
          :before-upload="handleUpload1"
          :show-upload-list="false"
          :on-success="uploadSuccess23"
          :on-error="uploadError"
          :multiple="false"
          :headers="uploadHeader"
          :data="uploadData"
          :on-format-error="handleFormatError2"
          :action="'/zituSpace/common/uploadFile'"
        >
          <Button
            v-if="isUploadPDF"
            style="margin-right: 10px; height: 32px"
            type="primary"
            icon="md-add"
          >
            上传附件
          </Button>
        </Upload>
        <Button type="default" @click="cancelexport1">关闭</Button>
      </div>
    </Modal>
    <!-- 当前级数的显示 -->
    <!-- <div class="jsNumber">当前级数为：第 {{ zoomNumber }} 级</div> -->
    <!-- 图片预览 -->
    <div class="images imagesArrCal" v-viewer="{ movable: true }" style="visibility: hidden">
      <img v-for="src in imagesArr" :src="src" :key="src" />
    </div>
  </div>
</template>
<script>
import OlBaseMap from './OlBaseMap';
export default OlBaseMap;
</script>
<style lang="less" scoped>
.olmap {
  height: 100%;
  width: 100%;
  position: absolute;
}
/deep/.ol-attribution {
  display: none;
}
#mouse-position {
  position: absolute !important;
  right: 220px !important;
  bottom: 30px !important;
  z-index: 99;
}
#scalebar {
  position: absolute;
  right: 320px;
  bottom: 0px;
  z-index: 3;
}
.basemap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
/deep/.midea-modal {
  z-index: 1000 !important;
  // /deep/.ivu-modal-content{
  //   right: -212%;
  // }
}
#olmapdiv .changemap {
  position: absolute;
  z-index: 6;
  outline: none;
  cursor: pointer;
  width: 30px;
  height: 28px;
  /* top: 56px; */
  bottom: 80px;
  right: 1.5% !important;
  border: 1px solid #8391a5;
  /*!*3d*! hover -240px 1px / 266px*/
  /*background: url(//weBMapGLGL0.bdimg.com/image/api/gl-navi-control-pc4.png) -188px 1px / 266px no-repeat rgb(255, 255, 255);*/
  /*!*2d*! -162px 1px / 266px*/
  background: url('../../../static/img/maptools.png') -188px 1px / 266px no-repeat rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.15) 1px 2px 1px;
}
#olmapdiv .changemap:hover {
  background: url('../../../static/img/maptools.png') -240px 1px / 266px no-repeat rgb(255, 255, 255);
}
.map-btn {
  position: absolute;
  right: 10px;
  top: 20px;
  z-index: 3;
  width: 60px;
  height: 50px;
  border: 2px solid #ffffff;
  background-size: 100% 100%;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  background: url(../../../static/maptool/img.png);
}
.map-btn2 {
  position: absolute;
  right: 80px;
  top: 20px;
  z-index: 3;
  width: 60px;
  height: 50px;
  border: 2px solid #ffffff;
  background-size: 100% 100%;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  background: url(../../../static/maptool/vector.png);
}
.map-xzq {
  position: absolute;
  right: 150px;
  top: 20px;
  z-index: 3;
  width: 60px;
  height: 50px;
  border: 2px solid #ffffff;
  background-size: 100% 100%;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  background: url(../../../static/maptool/district.png);
}
.map-btn-txt {
  position: absolute;
  right: 0;
  bottom: 0;
  width: auto;
  padding: 0 3px;
  background: rgba(0, 158, 218, 0.67);
  color: #fff;
  text-align: center;
  font-size: 12px;
  border-top-left-radius: 4px;
}

.map-btn-vector {
  position: absolute;
  right: 0;
  bottom: 0;
  width: auto;
  padding: 0 3px;
  background: rgba(0, 158, 218, 0.67);
  color: #fff;
  text-align: center;
  font-size: 12px;
  border-top-left-radius: 4px;
}

#mapType-wrapper.rb {
  position: absolute;
  bottom: 0px;
  right: 24% !important;
}
#mapType-wrapper.rt {
  position: absolute;
  top: 0px;
  right: 1%;
}
#mapType-wrapper.lb {
  position: absolute;
  bottom: 0px;
  left: 1%;
}
#mapType-wrapper.lt {
  position: absolute;
  top: 0px;
  left: 1%;
}
#mapType {
  height: 80px;
  cursor: pointer;
  -webkit-transition-property: width, background-color;
  transition-property: width, background-color;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  width: 110px;
  background-color: rgba(255, 255, 255, 0);
}

#mapType .mapTypeCard {
  height: 60px;
  width: 86px;
  position: absolute;
  border-radius: 2px;
  top: 10px;
  box-sizing: border-box;
  border: 1px solid transparent;
  border: 1px solid rgba(153, 153, 153, 0.42);
  background: url(../../../static/maptool/maptype.png) no-repeat 0 0;
  background-size: 86px 240px;
  -webkit-transition-property: right, background-image;
  transition-property: right, background-image;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}
#mapType .switch-box {
  visibility: hidden;
  position: absolute;
  width: 100%;
  height: 20px;
  line-height: 22px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
}
#mapType .mapTypeCard.active span {
  background-color: #3385ff;
}
#mapType .mapTypeCard:hover span {
  background-color: #3385ff;
}
#mapType .mapTypeCard span {
  position: absolute;
  bottom: 0;
  right: 0;
  display: inline-block;
  padding: 3px 3px 2px 4px;
  font-size: 12px;
  height: 16px;
  line-height: 12px;
  color: #fff;
  border-top-left-radius: 2px;
}
#mapType .satellite,
#mapType .earth {
  right: 2px;
  z-index: 3;
  background-position: 0 -181px;
}
#mapType .switch-box {
  visibility: hidden;
  position: absolute;
  width: 100%;
  height: 20px;
  line-height: 22px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
}

#mapType .normal {
  z-index: 4;
  right: 0px;
  background-image: url(../../../static/maptool/maptype.png);
  background-position: 0 0;
  border-left: 1px solid rgba(153, 153, 153, 0.6);
}

.expand #mapType {
  // width: 202px;
  // background-color: #fff;
  // background-color: rgba(255, 255, 255, 0.8);
}

.expand #mapType .mapTypeCard.active {
  border: 1px solid #3385ff;
}
.expand #mapType .mapTypeCard {
  border: 1px solid rgba(255, 255, 255, 0);
  background-image: url(../../../static/maptool/maptype.png);
}
.expand #mapType .satellite,
.expand #mapType .earth {
  right: 90px;
}
.ttt {
  color: red;
}
.jsNumber {
  position: absolute;
  bottom: 8px;
  right: 320px;
  width: 160px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: rgba(0, 60, 136, 0.3);
  color: #fff;
  border-radius: 4px;
  border-bottom: 1px solid #fff;
  padding: 0 2px;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/mapbase/OlBaseMap.vue